import * as action_types from "./constants";
import { CompanyListType, UpdateCompanyType } from "./types";

export type myCompanyState = {
  companyData: {
    loader: boolean;
    data: CompanyListType[] | null;
    count: number;
  };
  companyClientManager: { label: string; value: string }[];
  companyDetailData: {
    loader: boolean;
    data: UpdateCompanyType | null;
  };
};

const initialState: myCompanyState = {
  companyData: {
    loader: true,
    data: null,
    count: 0,
  },
  companyClientManager: [],
  companyDetailData: {
    loader: true,
    data: null,
  },
};

type MyCompanyActionType =
  | {
      type: typeof action_types.COMPANY_DETAILS;
      data: { payload: CompanyListType[]; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.CLIENT_MANAGER_FORM_LIST;
      data: { label: string; value: string }[];
    }
  | {
      type: typeof action_types.GET_COMPANY_DETAILS;
      data: { payload: UpdateCompanyType; loading: boolean };
    };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.COMPANY_DETAILS:
      return {
        ...state,
        companyData: {
          loader: false,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.CLIENT_MANAGER_FORM_LIST:
      return {
        ...state,
        companyClientManager: data,
      };

    case action_types.GET_COMPANY_DETAILS:
      return {
        ...state,
        companyDetailData: { data: data?.payload, loader: data?.loading },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
